import { render, staticRenderFns } from "./emailNotification.vue?vue&type=template&id=012f09ce&scoped=true"
import script from "./emailNotification.vue?vue&type=script&lang=js"
export * from "./emailNotification.vue?vue&type=script&lang=js"
import style0 from "./emailNotification.vue?vue&type=style&index=0&id=012f09ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f09ce",
  null
  
)

export default component.exports